export const DIV_LINE = 50; //分割数
export const DIV_CLICK = 2; //分割数
export const POLLING_INTERVAL1     = 1000; //1 sec
export const POLLING_INTERVAL10    = 10000; //10 sec
export const AI = true